import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {requestControllersWithActiveAlert} from "../../../redux/Actions/controllers.actions";
import {getControllersWithActiveAlert} from "../../../redux/Selectors/controllers.selectors";

export const useListControllersWithActiveAlerts = () => {
  const dispatch = useDispatch();
  const items = useSelector(getControllersWithActiveAlert);

  useEffect(() => {
    dispatch(requestControllersWithActiveAlert());
  }, [dispatch]);

  return {items};
};
